/**
 * Widgets de la pestaña «Insights» de la ficha de un producto. Todos menos el de
 * mercado leen la misma respuesta de GET /api/product-insights/:id y la agrupan
 * distinto (`view`); el de mercado busca en la web y solo se pide si está agregado.
 *
 * Mismo formato que los de la ficha del contacto (contactWidgetCatalog.js).
 */
import { placeNewWidget } from "@/components/gotrading/dashboard/widgetCatalog";

export const PRODUCT_WIDGETS = [
  { type: "product:summary", view: "summary", category: "general", icon: "box", preview: "kpi", size: { w: 12, h: 4 }, min: { w: 4, h: 3 } },
  { type: "product:operations", view: "operations", category: "general", icon: "list", preview: "list", size: { w: 6, h: 10 }, min: { w: 3, h: 5 } },
  { type: "product:by-month", view: "byMonth", category: "general", icon: "calendar-alt", preview: "columns", chart: "column", size: { w: 6, h: 9 }, min: { w: 3, h: 5 } },
  { type: "product:buyers", view: "buyers", category: "general", icon: "user-tie", preview: "bars", chart: "bar", size: { w: 6, h: 10 }, min: { w: 3, h: 5 } },
  { type: "product:sellers", view: "sellers", category: "general", icon: "industry", preview: "bars", chart: "bar", size: { w: 6, h: 10 }, min: { w: 3, h: 5 } },
  { type: "product:volume", view: "volume", category: "finance", icon: "chart-line", preview: "columns", chart: "column", finance: true, size: { w: 6, h: 9 }, min: { w: 3, h: 5 } },
  { type: "product:price", view: "price", category: "finance", icon: "tag", preview: "columns", chart: "line", finance: true, size: { w: 6, h: 9 }, min: { w: 3, h: 5 } },
  // Mercado, según la web: una búsqueda por producto que comparten todos (el primero
  // que se muestra la dispara). «product:market» es el resumen (así se llamaba cuando
  // era un solo widget).
  { type: "product:market", view: "market:summary", category: "market", icon: "globe", preview: "note", size: { w: 12, h: 5 }, min: { w: 4, h: 4 } },
  { type: "product:market-exporters", view: "market:exporters", category: "market", icon: "plane-departure", preview: "list", size: { w: 4, h: 10 }, min: { w: 3, h: 5 } },
  { type: "product:market-importers", view: "market:importers", category: "market", icon: "plane-arrival", preview: "list", size: { w: 4, h: 10 }, min: { w: 3, h: 5 } },
  { type: "product:market-prices", view: "market:prices", category: "market", icon: "tag", preview: "list", size: { w: 4, h: 8 }, min: { w: 3, h: 5 } },
  { type: "product:market-trends", view: "market:trends", category: "market", icon: "chart-line", preview: "list", size: { w: 6, h: 8 }, min: { w: 3, h: 5 } },
  { type: "product:market-companies", view: "market:companies", category: "market", icon: "building", preview: "list", size: { w: 6, h: 10 }, min: { w: 3, h: 5 } },
];

/** `ctx.finance`: el back dijo que puede ver montos. */
export function buildProductCatalog(ctx) {
  return PRODUCT_WIDGETS.filter((e) => !e.finance || ctx.finance).map((e) => ({
    ...e,
    kind: "product",
    config: e.chart ? { chart: e.chart } : {},
  }));
}

/** El de fábrica: resumen, operaciones por mes y la lista, compradores y proveedores. Sin los de mercado: buscan en la web y eso se elige. */
export function buildDefaultProductLayout(catalog) {
  const byType = Object.fromEntries(catalog.map((e) => [e.type, e]));
  const wanted = ["product:summary", "product:by-month", "product:operations", "product:buyers", "product:sellers", "product:price"];
  const out = [];
  wanted.forEach((type) => {
    const e = byType[type];
    if (!e) return;
    const pos = placeNewWidget(out, e.size.w);
    out.push({ i: type, type, x: pos.x, y: pos.y, w: e.size.w, h: e.size.h, config: { ...e.config } });
  });
  return out;
}
